import { usePage } from "@inertiajs/react";
import { useEffect } from "react";
import { toast } from "sonner";
import { Toaster } from "@/components/ui/sonner";
import type { SharedData } from "@/types";

export default function FlashMessageManager() {
  const { flash } = usePage<SharedData>().props;

  useEffect(() => {
    if (flash.success) {
      toast.success(flash.success);
    }

    if (flash.error) {
      toast.error(flash.error);
    }

    if (flash.info) {
      toast.info(flash.info);
    }
  }, [flash.success, flash.error, flash.info]);

  return <Toaster position="top-right" />;
}
